import React, { useState, useEffect, use } from 'react';
import Unit from '../Modular/Unit';
import Button from '../Button';
import './Calendar.css';
import Day from './Day';
import { useWindowSize } from '../../hooks/useWindowSize';

interface CalendarProps {
  selectDay: (day: number) => void;
  date: {
    year: number;
    month: number;
  };
  loadingAvailableDates: boolean;
  availableDates: number[];
}

const Calendar: React.FC<CalendarProps> = ({
  selectDay,
  date,
  loadingAvailableDates,
  availableDates,
}) => {
  const today = new Date();

  const year = date.year;
  const month = date.month;

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth = new Date(year, month, 1).getDay();

  const calendarDays = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  const windowSize = useWindowSize();
  const responsiveWidth = windowSize.width <= 798 ? '1' : '3';

  return (
    <>
      {!loadingAvailableDates && (
        <div className="calendar-grid">
          {Array.from({ length: firstDayOfMonth }, (_, i) => (
            <Button
              width={responsiveWidth}
              variant="outlinelight"
              disabled={true}
              key={i}
            >
              <div className="empty-space"></div>
            </Button>
          ))}
          {calendarDays.map((day, idx) => {
            const isAvailable = availableDates.includes(day);

            return (
              <Day
                day={day}
                selectDay={selectDay}
                isAvailable={isAvailable}
                month={month}
                width={responsiveWidth}
                key={idx}
              >
                {day}
              </Day>
            );
          })}
        </div>
      )}
    </>
  );
};

export default Calendar;
